import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import { adminMainUrl } from "../../../Config";
import Cookies from "js-cookie";
import { BeatLoader } from "react-spinners";
// import EditQuoteForm from './modal/EditQuoteForm';
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from 'react-toastify';
import { adminMainUrl } from "../../../Config";
import { FocusError } from "focus-formik-error";
import Select from "react-select";
import * as Yup from "yup";
import { getTransporterDetail } from "../../../Redux/action/Transport/TransportAction";
import { useSelector, useDispatch } from "react-redux";
const TransporterEdit = () => {
    const { b64id } = useParams();
    const dispatch = useDispatch()

    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);

    const validationSchema = Yup.object().shape({
        company_name: Yup.string().required("Please enter company name"),
        email: Yup.string().required("Please enter email"),
        phone_number: Yup.string().required("Please enter phone number"),
        primary_contact_name: Yup.string().required("Please enter primary contact person name"),
        designation: Yup.string().required("Please enter designation"),
    });

    const transporterTypeOptions = [
        { value: 'Fleet Operator', label: "Fleet Operator" },
        { value: 'Individual', label: "Individual" },
        { value: 'Aggregator', label: "Aggregator" },

    ]

    const operatingRegionsOptions = [
        { value: 'State', label: "State" },
        { value: 'City', label: "City" },

    ]

    const paymmentTermsOptions = [
        { value: 'Per Trip', label: "Per Trip" },
        { value: 'Monthly Contract', label: "Monthly Contract" },
        { value: 'Credit Days', label: "Credit Days" },


    ]

    const specialHandlingOptions = [
        { value: 'Hazardous Material', label: "Hazardous Material" },
        { value: 'Fragile Goods', label: "Fragile Goods" },
    ]


    const avVehicleOptions = [
        { value: 'Truck', label: "Truck" },
        { value: 'Mini-Truck', label: "Mini-Truck" },
        { value: 'Trailer', label: "Trailer" },
        { value: 'Van', label: "Van" },
    ]

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };
    const navigate = useNavigate()
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get("token");
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                let id = atob(b64id);
                if (token && id && user_id) {
                    dispatch(getTransporterDetail(token, user_id, id));
                }
            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }

    }, []);

    const formik = useFormik({
        initialValues: {

            company_name: "",
            transporter_type: "",
            registration_number: "",
            gst_number: "",
            pan_tin_number: "",
            primary_contact_name: "",
            designation: "",
            phone_number: "",
            email: "",
            office_address: "",
            operating_regions: "",
            available_vehicle_types: "",
            vehicle_capacity_unit: "",
            vehicle_capacity_ranges: "",
            total_fleet_size: "",
            refrigerated_transport: false,
            gps_tracking: false,
            licenses_certifications: "",
            insurance_details: "",
            past_clients_experience: "",
            payment_terms: "",
            dedicated_on_demand_service: "",
            special_handling_available: "",
            custom_quote_submission: false
        },
        validationSchema,
        onSubmit: (values, { resetForm }) => {


            setDisableSubmitBtn(true);
            try {
                let config = { headers: { 'auth-token': Cookies.get('token'), 'user_id': user_id, 'Content-Type': 'multipart/form-data' } }
                const formData = new FormData();

                formData.append("company_name", values.company_name);
                formData.append("transporter_type", values.transporter_type);
                formData.append("registration_number", values.registration_number);
                formData.append("gst_number", values.gst_number);
                formData.append("pan_tin_number", values.pan_tin_number);
                formData.append("primary_contact_name", values.primary_contact_name);
                formData.append("designation", values.designation);
                formData.append("phone_number", values.phone_number);
                formData.append("email", values.email);
                formData.append("office_address", values.office_address);
                formData.append("operating_regions", values.operating_regions);
                formData.append("available_vehicle_types", values.available_vehicle_types);
                formData.append("vehicle_capacity_unit", values.vehicle_capacity_unit);
                formData.append("vehicle_capacity_ranges", values.vehicle_capacity_ranges);
                formData.append("total_fleet_size", values.total_fleet_size);
                formData.append("refrigerated_transport", values.refrigerated_transport);
                formData.append("gps_tracking", values.gps_tracking);
                formData.append("licenses_certifications", values.licenses_certifications);
                formData.append("insurance_details", values.insurance_details);
                formData.append("past_clients_experience", values.past_clients_experience);
                formData.append("payment_terms", values.payment_terms);
                formData.append("dedicated_on_demand_service", values.dedicated_on_demand_service);
                formData.append("special_handling_available", values.special_handling_available);
                formData.append("custom_quote_submission", values.custom_quote_submission);

                axios.post(`${adminMainUrl}/api/master/transporter/update?id=${atob(b64id)}`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            setDisableSubmitBtn(false);
                            toast.success(response?.data?.msg);


                        } else {
                            setDisableSubmitBtn(false);
                            toast.error(response?.data?.msg)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        setDisableSubmitBtn(false);
                        let msg = "";
                        if (err.response) {
                            msg = err.response.data.msg;
                        } else {
                            msg = "Internal Server Error!"
                        };
                        toast.error(msg);
                    })
            } catch (error) {
                setDisableSubmitBtn(false);
                console.log(error);
                toast.error("Internal Server Error!")
            }
        }
    });

    const {
        loadingTransporterDetail,
        transporterDetailDataError,
        transporterDetailData
    } = useSelector(state => state?.TransportReducer);

    const [filePreview, setFilePreview] = useState(null);
    useEffect(() => {
        if (transporterDetailData) {

            formik.setValues({
                company_name: transporterDetailData?.company_name ?? "",
                transporter_type: transporterDetailData?.transporter_type ?? "",
                registration_number: transporterDetailData?.registration_number ?? "",
                gst_number: transporterDetailData?.gst_number ?? "",
                pan_tin_number: transporterDetailData?.pan_tin_number ?? "",
                primary_contact_name: transporterDetailData?.primary_contact_name ?? "",
                designation: transporterDetailData?.designation ?? "",
                phone_number: transporterDetailData?.phone_number ?? "",
                email: transporterDetailData.email ?? "",
                office_address: transporterDetailData.office_address ?? "",
                operating_regions: transporterDetailData.operating_regions ?? "",
                available_vehicle_types: transporterDetailData.available_vehicle_types ?? "",
                vehicle_capacity_unit: transporterDetailData.vehicle_capacity_unit ?? "",
                vehicle_capacity_ranges: transporterDetailData.vehicle_capacity_ranges ?? "",

                total_fleet_size: transporterDetailData?.contractCustomerWitnessName ?? "",
                refrigerated_transport: transporterDetailData?.refrigerated_transport ?? "",
                gps_tracking: transporterDetailData?.gps_tracking ?? "",
                licenses_certifications: transporterDetailData?.licenses_certifications ?? "",
                insurance_details: transporterDetailData?.insurance_details ?? "",
                past_clients_experience: transporterDetailData?.past_clients_experience ?? "",

                payment_terms: transporterDetailData?.payment_terms ?? "",
                dedicated_on_demand_service: transporterDetailData?.dedicated_on_demand_service ?? "",
                special_handling_available: transporterDetailData?.special_handling_available ?? "",
                custom_quote_submission: transporterDetailData?.custom_quote_submission ?? "",


            })
            setFilePreview(`${adminMainUrl}/${transporterDetailData?.licenses_certifications}`)
        }
    }, [transporterDetailData])


    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            formik.setFieldValue('licenses_certifications', file); // Update formik field value
            setFilePreview(URL.createObjectURL(file)); // Set the preview URL
        }
    };


    return (
        <>
            <div className="page-wrapper">
                <form onSubmit={formik.handleSubmit}>
                    <FocusError formik={formik} />
                    <div className="content">
                        <div className="row">
                            <div className="col-md-12">
                                {/* Page Header */}
                                <div className="page-header">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h4 className="page-title">Transporter Form</h4>
                                        </div>
                                    </div>
                                </div>
                                {/* /Page Header */}
                            </div>
                        </div>
                        <div className="card">

                            <div className="card-body">


                                <div className="main_detail_form mt-4">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">General information</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Company Name <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="company_name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Company Name"
                                                    value={formik?.values?.company_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length == 0 &&
                                                            event.key == " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.company_name &&
                                                    formik?.errors.company_name ? (
                                                    <div className="error">
                                                        {formik?.errors.company_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Transporter Type 
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={transporterTypeOptions}
                                                    name="transporter_type"
                                                    value={transporterTypeOptions.find(option => option.value == formik.values.transporter_type)}
                                                    onChange={option => formik.setFieldValue('transporter_type', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.transporter_type && formik.errors.transporter_type ? (
                                                    <div className="error">{formik.errors.transporter_type}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Registration Number 
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Registration Number"
                                                    name="registration_number"
                                                    value={formik?.values?.registration_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="\d*"
                                                    onKeyPress={(event) => {
                                                        if (!/\d/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    maxLength={30}
                                                />
                                                {formik?.touched?.registration_number && formik?.errors?.registration_number ? (
                                                    <div className="error">{formik?.errors?.registration_number}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    GST Number 
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter GST Number"
                                                    name="gst_number"
                                                    value={formik?.values?.gst_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                   
                                                    onKeyPress={(event) => {
                                                        if (!/\d/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    maxLength={30}
                                                />
                                                {formik?.touched?.gst_number && formik?.errors?.gst_number ? (
                                                    <div className="error">{formik?.errors?.gst_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    PAN/TIN Number 
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter PAN/TIN Number"
                                                    name="pan_tin_number"
                                                    value={formik?.values?.pan_tin_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                   
                                                    onKeyPress={(event) => {
                                                        if (!/\d/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    maxLength={30}
                                                />
                                                {formik?.touched?.pan_tin_number && formik?.errors?.pan_tin_number ? (
                                                    <div className="error">{formik?.errors?.pan_tin_number}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                    </div>
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Contact Information</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Primary Contact Person Name <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="primary_contact_name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Primary Contact Person Name"
                                                    value={formik?.values?.primary_contact_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length == 0 &&
                                                            event.key == " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.primary_contact_name &&
                                                    formik?.errors.primary_contact_name ? (
                                                    <div className="error">
                                                        {formik?.errors.primary_contact_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Designation <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="designation"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Designation"
                                                    value={formik?.values?.designation}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length == 0 &&
                                                            event.key == " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.designation &&
                                                    formik?.errors.designation ? (
                                                    <div className="error">
                                                        {formik?.errors.designation}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Phone Number <span>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Phone Number"
                                                    name="phone_number"
                                                    value={formik?.values?.phone_number}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                  
                                                    onKeyPress={(event) => {
                                                        if (!/\d/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    maxLength={10}
                                                />
                                                {formik?.touched?.phone_number && formik?.errors?.phone_number ? (
                                                    <div className="error">{formik?.errors?.phone_number}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Email Id <span>*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Email"
                                                    name="email"
                                                    value={formik?.values.email}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                />
                                                {formik?.touched.email && formik?.errors?.email ? (
                                                    <div className="error">{formik?.errors?.email}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Official Address 
                                                </label>
                                                <input
                                                    type="text"
                                                    name="office_address"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Official Address"
                                                    value={formik?.values?.office_address}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length == 0 &&
                                                            event.key == " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.office_address &&
                                                    formik?.errors.office_address ? (
                                                    <div className="error">
                                                        {formik?.errors.office_address}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Operating Regions 
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={operatingRegionsOptions}
                                                    name="operating_regions"
                                                    value={operatingRegionsOptions.find(option => option.value == formik.values.operating_regions)}
                                                    onChange={option => formik.setFieldValue('operating_regions', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.operating_regions && formik.errors.operating_regions ? (
                                                    <div className="error">{formik.errors.operating_regions}</div>
                                                ) : null}
                                            </div>
                                        </div>


                                    </div>
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Fleet Details</h4>
                                    </div>
                                    <div className="row">

                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Available Vehicle Type 
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={avVehicleOptions}
                                                    name="available_vehicle_types"
                                                    value={avVehicleOptions.find(option => option.value == formik.values.available_vehicle_types)}
                                                    onChange={option => formik.setFieldValue('available_vehicle_types', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.available_vehicle_types && formik.errors.available_vehicle_types ? (
                                                    <div className="error">{formik.errors.available_vehicle_types}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="   ">
                                                <label htmlFor="weight" className="form-label">
                                                    Vehicle Capacity Ranges{" "}
                                                   
                                                </label>
                                                <div className="dimensions-input-container">
                                                    <div className="input-wrapper">
                                                        <input
                                                            type="number"
                                                            min={1}
                                                            placeholder="W"
                                                            name='vehicle_capacity_ranges'
                                                            value={formik.values.vehicle_capacity_ranges}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}

                                                            pattern="\d*"
                                                            maxLength={8}
                                                            onKeyPress={(event) => {
                                                                if (!/\d/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            className="dimension-input form-control form-control-sm"
                                                        />
                                                    </div>

                                                    <select
                                                        id='vehicle_capacity_unit'
                                                        className="unit-select form-select"
                                                        name='vehicle_capacity_unit'
                                                        value={formik.values.vehicle_capacity_unit}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}

                                                    >
                                                        <option value="" disabled>Unit</option>
                                                        <option value="Ton">Ton</option>
                                                        <option value="Kgs">Kgs</option>
                                                        <option value="Lbs">Lbs</option>

                                                    </select>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Total Fleet Size 
                                                </label>
                                                <input
                                                    type="text"
                                                    name="total_fleet_size"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Total Fleet Size"
                                                    value={formik?.values?.total_fleet_size}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    pattern="[a-zA-Z\s]*"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length == 0 &&
                                                            event.key == " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.total_fleet_size &&
                                                    formik?.errors.total_fleet_size ? (
                                                    <div className="error">
                                                        {formik?.errors.total_fleet_size}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-check form-switch ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Refrigerated Transport Available 
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckDefault"
                                                    name="refrigerated_transport"
                                                    checked={formik.values.refrigerated_transport}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("refrigerated_transport", e.target.checked);

                                                    }}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-check form-switch ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    GPS Tracking Enabled? 
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckDefault"
                                                    name="gps_tracking"
                                                    checked={formik.values.gps_tracking}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("gps_tracking", e.target.checked);

                                                    }}
                                                />

                                            </div>
                                        </div>




                                    </div>


                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Service & Compliance Details</h4>
                                    </div>
                                    <div className="row">

                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label htmlFor="licenses_certifications" className="form-label">
                                                    Licenses & Certifications 
                                                </label>
                                                <input
                                                    type="file"
                                                    name="licenses_certifications"
                                                    className="form-control form-control-sm"
                                                    onChange={(e) => { handleFileChange(e) }}
                                                />
                                                {formik.touched.licenses_certifications && formik.errors.licenses_certifications ? (
                                                    <div className="error">{formik.errors.licenses_certifications}</div>
                                                ) : null}
                                            </div>
                                            {filePreview && (
                                                <div className="image-preview mt-2">
                                                    <img src={filePreview} alt="Preview" className="img-thumbnail" style={{ width: '200px', height: 'auto' }} />
                                                </div>
                                            )}
                                        </div>


                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Insurance Details <span></span>
                                                </label>
                                                <textarea


                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Temperature in Celsius"
                                                    name="insurance_details"
                                                    value={formik?.values.insurance_details}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                />

                                                {formik.touched.insurance_details && formik.errors.insurance_details ? (
                                                    <div className="error">{formik.errors.insurance_details}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Past Clients/Experience  <span></span>
                                                </label>
                                                <textarea
                                                    type="past_clients_experience"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Past Clients/Experience "
                                                    name="past_clients_experience"
                                                    value={formik?.values.past_clients_experience}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                />
                                                {formik?.touched.past_clients_experience && formik?.errors?.past_clients_experience ? (
                                                    <div className="error">{formik?.errors?.past_clients_experience}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Payment Terms Preferred 
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={paymmentTermsOptions}
                                                    name="payment_terms"
                                                    value={paymmentTermsOptions.find(option => option.value == formik.values.payment_terms)}
                                                    onChange={option => formik.setFieldValue('payment_terms', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.payment_terms && formik.errors.payment_terms ? (
                                                    <div className="error">{formik.errors.payment_terms}</div>
                                                ) : null}
                                            </div>
                                        </div>


                                    </div>


                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Additional Features</h4>
                                    </div>
                                    <div className="row">



                                        <div className="col-md-4">
                                            <div className="form-check form-switch ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Refrigerated Transport Available 
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckDefault"
                                                    name="dedicated_on_demand_service"
                                                    checked={formik.values.dedicated_on_demand_service}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("dedicated_on_demand_service", e.target.checked);

                                                    }}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input_box_section">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Special Handling Available 
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    options={specialHandlingOptions}
                                                    name="special_handling_available"
                                                    value={specialHandlingOptions.find(option => option.value == formik.values.special_handling_available)}
                                                    onChange={option => formik.setFieldValue('special_handling_available', option.value)}
                                                    onBlur={formik.handleBlur}
                                                />

                                                {formik.touched.special_handling_available && formik.errors.special_handling_available ? (
                                                    <div className="error">{formik.errors.special_handling_available}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-check form-switch ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Custom Quote Submission Option? 
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id="flexSwitchCheckDefault"
                                                    name="custom_quote_submission"
                                                    checked={formik.values.custom_quote_submission}
                                                    onChange={(e) => {
                                                        formik.setFieldValue("custom_quote_submission", e.target.checked);

                                                    }}
                                                />

                                            </div>
                                        </div>


                                    </div>


                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <button
                                            className="btn btn-main-form me-md-2"
                                            type="submit"
                                            disabled={disableSubmitBtn}
                                        >
                                            {disableSubmitBtn ? <><i className="fas fa-spinner fa-spin"></i> Saving</> : "Create Quotation"}
                                        </button>
                                    </div>
                                </div>





                            </div>
                        </div>
                    </div>
                </form >
            </div >
        </>
    )
}

export default TransporterEdit